import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import FileDialogButtonView from "@ckeditor/ckeditor5-upload/src/ui/filedialogbuttonview"
import api from "../../honcierge-api"
import store from "../../store"

export default class InsertImageWithoutIsbnUI extends Plugin {
  init() {
    const editor = this.editor
    const role = store.state.adminUser.role
    if (role === "editor" || role === "administrator") {
      editor.ui.componentFactory.add("insertImageWithoutIsbn", (locale) => {
        const view = new FileDialogButtonView(locale)
        view.set({
          acceptedType: "image/*",
          allowMultipleFiles: false,
        })

        view.buttonView.set({
          label: "Amazonにない本",
          withText: true,
          toolTip: true,
        })

        view.on("done", (_event, files) => {
          if (files.length != 1) {
            return
          } else {
            api
              .createDirectUpload(files[0])
              .then((res) => {
                api
                  .getImageUrl(res.id)
                  .then((res) => {
                    editor.execute("imageInsertWithoutIsbn", {
                      source: [res.data.url],
                    })
                  })
                  .catch(() => {
                    console.log("image without isbn insert error")
                  })
              })
              .catch(() => {
                console.log("direct upload error in image without isbn")
              })
          }
        })
        return view
      })
    }
  }
}
